/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { AsyncValidatorFn, FormControl, ValidatorFn } from '@angular/forms';
import { Type } from '@gh/core-type';
import { ControlSchemaPackedValue } from '../form-schema';
import { FormControlSchema, FormControlSchemaConfig } from '../form-schema/form-control-schema';
import { AppControl } from './app-control';

export class AppFormControl extends FormControl implements AppControl {
  key?: string;
  required: boolean;
  visible: boolean;
  privilegedEntryPoint?: string[];
  type?: Type<any>;
  lastValidators?: ValidatorFn[];
  lastAsyncValidators?: AsyncValidatorFn[];

  constructor(private schema: FormControlSchema,
              formState?: any, validator?: ValidatorFn | ValidatorFn[],
              asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[]) {
    super(formState, validator, asyncValidator);
    this.key = schema.key;
  }

  updateSchema(config: FormControlSchemaConfig, packedValue?: ControlSchemaPackedValue): void {
    this.schema.update(config);
    this.schema.applyTo(this, packedValue);
  }
}
